import { TAGS_DIRECTORY, TAGS_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const tagsDirectoryRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: TAGS_DIRECTORY,
	path: TAGS_PATH,
	subproduct: 'townsquare-tags',
});
